import { RightOutline } from "antd-mobile-icons";
import React from "react";

import styles from "./style.module.scss";

function MenuListItem({ itemOnClick = () => {}, icon = "", title = "", hasBottomBorder = false }) {
  return (
    <>
      <div className={styles.menuListItem}>
        <div className={styles.itemContainer} onClick={itemOnClick}>
          {icon}
          <div className={styles.rightSide}>
            <div className={styles.title}>{title}</div>
            <RightOutline color="var(--profile-form-icon)" />
          </div>
        </div>
      </div>
      {hasBottomBorder ? <div className={styles.border}></div> : ""}
    </>
  );
}

export default MenuListItem;
